import React from "react";
import { Container, Grid } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";

import phivolcs_seal from "../../assets/phivolcs_seal2.png";
import dynaslope_seal from "../../assets/dynaslope_seal2.png";
import provincial_seal from "../../assets/Bukidnon3.png";
import municipal_seal from "../../assets/Kibawe3.png";
import mdrrmo_seal from "../../assets/kibawe_mdrrmo_logo2.png";
import brgy_seal from "../../assets/brgy_logo3.png";
import lewc_seal from "../../assets/Magsaysay_LEWC2.png";
import { Box } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  md_image: {
    length: "85px",
    width: "85px",
    [theme.breakpoints.down("sm")]: {
      length: "60px",
      width: "60px",
    },
  },
  sm_image: {
    length: "70px",
    width: "75px",
    marginLeft: "12px",
    [theme.breakpoints.down("sm")]: {
      length: "50px",
      width: "50px",
    },
  },
  lg_image: {
    length: "100px",
    width: "100px",
    [theme.breakpoints.down("sm")]: {
      length: "70px",
      width: "70px",
    },
  },
  lrg_image: {
    length: "85px",
    width: "96px",
    [theme.breakpoints.down("sm")]: {
      length: "70px",
      width: "70px",
    },
  },
}));

function SignInLogo(props) {
  const classes = useStyles();

  return (
    <Container>
      <Grid
        container
        alignItems="center"
        style={{
          paddingTop: "2%",
          paddingBottom: "1%",
          justifyContent: "space-between",
          // textAlign: "center",
        }}
      >
        <img
          className={classes.lg_image}
          src={phivolcs_seal}
          alt="phivolcs_seal"
        />
        <img
          className={classes.sm_image}
          src={dynaslope_seal}
          alt="dynaslope_seal"
        />
        <img
          className={classes.md_image}
          src={provincial_seal}
          alt="province_seal"
        />
        <img
          className={classes.md_image}
          src={municipal_seal}
          alt="municipality_seal"
        />
        <img className={classes.lrg_image} src={mdrrmo_seal} alt="mdrrmo_seal" />
        <img className={classes.md_image} src={brgy_seal} alt="brgy_seal" />
        <img className={classes.md_image} src={lewc_seal} alt="lewc_seal" />
      </Grid>
    </Container>
  );
}

export { SignInLogo };
